import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTenancy } from '@/contexts/TenancyContext';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious, PaginationEllipsis } from "@/components/ui/pagination";
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger, SheetClose } from '@/components/ui/sheet';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogClose } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { Separator } from '@/components/ui/separator';
import { Search, Download, ExternalLink, FileText, ShieldAlert, CheckCircle, Info, ChevronRight, Eye } from 'lucide-react';
import { AuditorLayout } from '../components/AuditorLayout';

// SOA service import (reusing existing service)
import { getSOAData } from '@/services/soaService';
import {
  Control,
  Framework,
  ImplementationStatus,
  FrameworkStats,
  SOAData,
  emptySOAData
} from '@/types/soa';
import ManagementSystemGuide from '../../msg';


// Auditor MSG component - read-only version of the MSG page
const AuditorMSG: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { activeTenancy, isModuleEnabled } = useTenancy();
  const [tenancyId, setTenancyId] = useState<string | null>(null);

  // Return the component JSX with isReadOnly=true
  return (
      <ManagementSystemGuide basePath="/auditor-view/msg" isReadOnly={true} />
  );
};

export default AuditorMSG;
